'use client';
import { usePathname } from 'next/navigation';
import { OffersAlertBar } from './OffersAlertBar';

const HIDDEN_PREFIXES = ['/account', '/checkout', '/cart', '/login', '/payment', '/review', '/support'];

export function OffersAlertBarClient({ offers }) {
    const pathname = usePathname();

    if (!offers) return null;
    if (HIDDEN_PREFIXES.some(p => pathname.startsWith(p))) return null;

    return <OffersAlertBar offers={offers} />;
}
